import { z } from '@uturn/portal/zod';

export const MAX_UTURN_NOTE_LENGTH = 8000;

export const messageSchema = z.object({
	uturnNote: z.string().trim().min(1).max(MAX_UTURN_NOTE_LENGTH),
});

export type MessageForm = z.infer<typeof messageSchema>;
